import { render, staticRenderFns } from "./SeminarStudentHistoryHeader.vue?vue&type=template&id=cd4dbc48&scoped=true&lang=pug&"
import script from "./SeminarStudentHistoryHeader.vue?vue&type=script&lang=ts&"
export * from "./SeminarStudentHistoryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SeminarStudentHistoryHeader.vue?vue&type=style&index=0&id=cd4dbc48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4dbc48",
  null
  
)

export default component.exports